import React from 'react'

import { DNAModal, DNAText } from '@alucio/lux-ui'
import { DNAModalVariant } from 'src/components/DNA/Modal/DNAConnectedModal'

export type DNAIntegrationSyncModalProps = {
  onChange: (syncVal: boolean) => void
}

const DNAIntegrationSyncModal: DNAModalVariant<DNAIntegrationSyncModalProps> = (props) => {
  const { toggleModal, onChange } = props

  const onAction = () => {
    onChange(true)
    toggleModal()
  }

  const onCancel = () => {
    onChange(false)
    toggleModal()
  }

  return (
    <DNAModal>
      <DNAModal.Header>Disable syncing?</DNAModal.Header>
      <DNAModal.Message>
        This will disable the integration.
      </DNAModal.Message>
      <DNAModal.Body>
        <DNAText bold>{}</DNAText>
      </DNAModal.Body>
      <DNAModal.Confirmation
        onCancel={onCancel}
        onAction={onAction}
        actionLabel="Disable"
        actionStatus="primary"
      />
    </DNAModal>
  )
}

export default DNAIntegrationSyncModal
